/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Message } from './message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
    MessageToJSONTyped,
} from './message';

/**
 * 
 * @export
 * @interface WsNewMessage
 */
export interface WsNewMessage {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsNewMessage
     */
    type: string | null;
    /**
     * 
     * @type {Message}
     * @memberof WsNewMessage
     */
    message: Message;
}

/**
 * Check if a given object implements the WsNewMessage interface.
 */
export function instanceOfWsNewMessage(value: object): value is WsNewMessage {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function WsNewMessageFromJSON(json: any): WsNewMessage {
    return WsNewMessageFromJSONTyped(json, false);
}

export function WsNewMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsNewMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'message': MessageFromJSON(json['message']),
    };
}

export function WsNewMessageToJSON(json: any): WsNewMessage {
    return WsNewMessageToJSONTyped(json, false);
}

export function WsNewMessageToJSONTyped(value?: WsNewMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'message': MessageToJSON(value['message']),
    };
}

